module.exports = {"Born1":{"daobanList":[{"title":"1:办理水电气网联合报装一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、身份证明","state":"必要"},{"name":"2、经办人的身份证原件及复印件（正反面）","state":"必要"},{"name":"3、单位有效证件（复印件加盖印章），如：统一社会信用代码证","state":"必要"},{"name":"4、授权委托书（加盖印章）","state":"必要"},{"name":"5、签署产品合同/受理单","state":"必要"},{"name":"6、签署《广东联通电信业务信息安全责任承诺书》","state":"必要"},{"name":"7、物业权属证明","state":"必要"},{"name":"8、可供水证明","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx38.json
// module id = 1335
// module chunks = 0